import SectionHero from "components/SectionHero/SectionHero";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import React, { useEffect, useRef, useState } from "react";
import SectionOurFeatures from "components/SectionOurFeatures/SectionOurFeatures";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import SectionHowItWork from "components/SectionHowItWork/SectionHowItWork";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { HotelType, TaxonomyType } from "data/types";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import supabase from "utils/supabaseClient";
import { DEMO_AUTHORS } from "data/authors";
import useAuth from "components/Authprovider/Auth";
import useSearch from "components/SearchContext/SearchContext";
import toast from "react-hot-toast";
import scrollToX from "utils/scrollToX";
import { fetchData } from "data/api/fetch";

const DEMO_AUTHOR = DEMO_AUTHORS.filter((_, i) => i < 10);

function PageHome() {

  const {search,token} = useAuth()
  const {state,setState} = useSearch()
  
  const [Categories, setCategories] =useState<TaxonomyType[]>()
  const [hotelsData, setHotelsData] =useState<HotelType[]>()
  const firstRender = useRef(true);

  const headers = {
    "content-type": "application/json",
    "Accept": "application/json",
    "Authorization": `Bearer ${token}`,
  };

 
  useEffect(() =>{
    if (firstRender.current) {
      firstRender.current = false;
    } else {

        const getHotels = fetchData(`https://phplaravel-930928-3230982.cloudwaysapps.com/api/search-hotel?q=${search?.location}`,{},headers)

        toast.promise(getHotels, {
          loading: "Loading data...",
          success: (data: any) => `${data.msg}`,
          error: (error) => `No search results found`,
        });
        getHotels.then((data: any) => {
          // Use setData to update the state with the data
          setHotelsData(data.data)
          scrollToX('nc-SectionGridFeaturePlaces')
        });
      }
  },[search?.location])

  useEffect(() =>{
    const fetchCategories = async ()=>{
      
      let { data: categories, error } = await supabase
        .from('categories')
        .select()

        if(categories){
          setCategories(categories)
        }

        if(error){
          console.log(error)
          return error
        }
    }

    fetchCategories()
    //fetchTopAuthors()
},[])

  useEffect(() =>{
    const getHotels = fetchData(`https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel`,{},headers)

    getHotels.then((data: any) => {
      // Use setData to update the state with the data
      setHotelsData(data.data)
    });
     
  },[])

  useEffect(() =>{
    console.log(state.location)
  },[search?.location])

  

  return (
    <div className="nc-PageHome relative overflow-hidden">
      {/* GLASSMOPHIN */}
      <BgGlassmorphism />

      <div className="container relative space-y-24 mb-24 lg:space-y-28 lg:mb-28">
        {/* SECTION HERO */}
        <SectionHero className="pt-10 lg:pt-16 lg:pb-16" />

        {/* SECTION 1 */}
        <SectionSliderNewCategories
          categories={Categories}
          uniqueClassName="PageHome_s1"
        />

        {/* SECTION2 */}
        <SectionOurFeatures />

        {/* SECTION */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionGridFeaturePlaces  stayListingsHotel={hotelsData}/>
        </div>

        {/* SECTION */}
        <SectionHowItWork />

        {/* SECTION */}
        <div className="relative py-16">
          <BackgroundSection className="bg-primary-50 dark:bg-black dark:bg-opacity-20"/>
          <SectionClientSay uniqueClassName="PageHome_" />
        </div>
      </div>
    </div>
  );
}

export default PageHome;
